import { Component, OnInit } from '@angular/core';
import { UsersApi } from '@tytapp/api';
import { 
  NamedDialog, FormComponent, FormInput, Shell, 
  DialogComponent, PageService, Transfer 
} from '@tytapp/common';
import { User } from '@tytapp/models';
import { MessageDialogComponent } from '../message-dialog/message-dialog.component';

@NamedDialog('confirmation-required')
@Component({
  selector: 'tyt-confirmation-required',
  templateUrl: './confirmation-required.component.html',
  styleUrls: ['./confirmation-required.component.scss']
})
export class ConfirmationRequiredComponent extends DialogComponent implements FormComponent {

  constructor(
    pageService : PageService,
    private userApi : UsersApi
  ) { 
    super(pageService);
  }

  @FormInput()
  userId : string;

  init(userId) {
    this.userId = userId;
  }

  async submit() {
    await this.userApi.sendConfirmationEmail({ email: this.userId }).toPromise();
    this.shell.showDialog(MessageDialogComponent, 'Email Sent', 'A new confirmation email has been sent. Please check your inbox.');
  }
}
